<template>
  <Header header__white="header__white" />
  <Breadcrumb title="navbar.raqamlash" subtitle="navbar.raqamlash" />
  <raqam />
  <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Home/Header.vue';
import Breadcrumb from '../components/common/Breadcrumb.vue';
import raqam from '../components/common/raqam.vue';
import Footer from '../components/Home/Footer.vue';

export default {
  name:'AboutPage',
  components:{
    Header,
    Breadcrumb,
    raqam,
    Footer,
  }
}
</script>
